import request from '../utils/request'

export default {
  // 获取所有组织机构
  findAll(params) {
    return request.get('/api/org', { params })
  },
  
  // 根据ID获取组织机构
  findById(id) {
    return request.get(`/api/org/${id}`)
  },

  // 根据userID获取组织机构
  findByUserId(id) {
    return request.get(`/api/org/user/${id}`)
  },
  
  // 添加组织机构
  add(org) {
    return request.post('/api/org', org)
  },
  
  // 更新组织机构
  update(id, org) {
    return request.put(`/api/org/${id}`, org)
  },
  
  // 删除组织机构
  delete(id) {
    return request.delete(`/api/org/${id}`)
  },
  
  // 批量删除组织机构
  deleteBatch(ids) {
    return request.delete('/api/org/batch', { data: ids })
  },

}